import { classNames } from '@/shared/lib/classNames/classNames';
import cls from './Menu.module.scss';
import { AppLink, AppLinkTheme } from '@/shared/ui/AppLink';

interface MenuProps {
    className?: string;
}

export const ContactMenu = (props: MenuProps) => {
    const { className } = props;

    return (
        <nav className={classNames(cls.Menu, {}, [className])}>
            <ul className={cls.list}>
                <li className={cls.item}>
                    <AppLink className={cls.blockItem} to="tel:900" theme={AppLinkTheme.PRIMARY}>
                        900
                    </AppLink>
                </li>
                <li className={cls.item}>
                    <AppLink to="tel:+74955005550" className={cls.blockItem} theme={AppLinkTheme.PRIMARY}>
                        8 495 500-55-50
                    </AppLink>
                </li>
            </ul>
        </nav>
    );
};
